import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import Menu, { SubMenu, MenuItem } from 'rc-menu';
import $ from 'jquery/dist/jquery';
import _ from 'underscore';

import { webApiConfig } from 'src/config';

const path = {
  1: '/service/top',
  '2-1': '/service/bbt_racks',
  '3-1-1': '/service/system_monitoring_messages'
};

const currentPathKey = (location) => {
  const result = Object.keys(path).filter((k) => {
    return path[k] == location;
  })[0];
  if (result) {
    return result;
  } else {
    return '1';
  }
};

const genDefaultOpenKeys = (key) => {
  const defaultOpenKeys = [];
  const array = key.split('-');
  for (let i = array.length; i > 0; i -= 1) {
    defaultOpenKeys.push(array.join('-'));
    array.pop();
  }
  return defaultOpenKeys;
};

const NavBar = () => {
  const location = useLocation();
  const history = useHistory();
  const { getAccessTokenSilently } = useAuth0();

  const [defaultSelectedKeys, setDefaultSelectedKeys] = useState([
    currentPathKey(location.pathname)
  ]);
  const [defaultOpenKeys, setDefaultOpenKeys] = useState(
    genDefaultOpenKeys(currentPathKey(location.pathname))
  );
  const [disabledMenus, setDisabledMenus] = useState({
    bbt_rack: {
      index: true
    },
    system_monitoring_message: {
      index: true
    }
  });

  useEffect(() => {
    let isMounted = true;

    const _setDisabledMenus = async () => {
      const accessToken = await getAccessTokenSilently();
      let results = await $.ajax({
        url: `${webApiConfig.baseUri.bff}/common/accounts/abilities`,
        type: 'GET',
        async: false,
        dataType: 'json',
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', `Bearer ${accessToken}`);
        }
      }).responseText;
      results = results ? JSON.parse(results) : [];
      const newDisabledMenus = disabledMenus;
      _.keys(results).forEach((domain) => {
        results[domain].forEach((ability) => {
          const domain_name = domain.replace(/\//g, '_');
          if (disabledMenus[domain_name]) {
            newDisabledMenus[domain_name][ability] = false;
          }
        });
      });
      if (isMounted) {
        setDisabledMenus({ ...disabledMenus, ...newDisabledMenus });
      }
    };

    _setDisabledMenus();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      setDefaultSelectedKeys([currentPathKey(location.pathname)]);
      setDefaultOpenKeys(genDefaultOpenKeys(currentPathKey(location.pathname)));
    }

    return () => {
      isMounted = false;
    };
  }, [location.pathname]);

  const onClick = (info) => {
    history.push(path[info.key]);
  };

  const onTitleClick = (info) => {
    if (defaultOpenKeys.find((key) => key === info.key)) {
      const newKeys = defaultOpenKeys.filter((key) => key !== info.key);
      setDefaultOpenKeys(newKeys);
    } else {
      setDefaultOpenKeys([...defaultOpenKeys, info.key]);
    }
  };

  return (
    <div>
      <div>
        <Menu
          onClick={onClick}
          mode="inline"
          selectedKeys={defaultSelectedKeys}
          openKeys={defaultOpenKeys}
        >
          <MenuItem key="1">ホーム</MenuItem>
          <SubMenu key="2" title="データセンター" onTitleClick={onTitleClick}>
            <MenuItem key="2-1" disabled={disabledMenus.bbt_rack.index}>
              ラック電流値管理
            </MenuItem>
          </SubMenu>
          <SubMenu key="3" title="MSP" onTitleClick={onTitleClick}>
            <SubMenu
              className="rc-menu-nest-submenu"
              key="3-1"
              title="監視"
              onTitleClick={onTitleClick}
            >
              <MenuItem
                key="3-1-1"
                disabled={disabledMenus.system_monitoring_message.index}
              >
                自動電話通知ログ
              </MenuItem>
            </SubMenu>
          </SubMenu>
        </Menu>
      </div>
    </div>
  );
};

export default NavBar;
